import { render, staticRenderFns } from "./myProfileHeader.vue?vue&type=template&id=edf05a52&scoped=true"
import script from "./myProfileHeader.vue?vue&type=script&lang=js"
export * from "./myProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./myProfileHeader.vue?vue&type=style&index=0&id=edf05a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf05a52",
  null
  
)

export default component.exports